import * as React from "react";
import { SegmentCardsProps } from "./PredefinedSegments.types";
import SegmentCard from "./SegmentCard/SegmentCard";
import { Box } from "@tiny/components";
import { usePredefinedSegmentsContext } from "./PredefinedSegments.context";
import SegmentCardDisabled from "./SegmentCard/SegmentCardDisabled";

function SegmentCards({
  id,
  cards,
  selected,
  selectionDisabled,
  onSegmentSelect,
}: SegmentCardsProps) {
  const { isDisabled } = usePredefinedSegmentsContext();
  const Card = isDisabled ? SegmentCardDisabled : SegmentCard;

  return (
    <Box
      id={id}
      display="grid"
      gap="16px"
      gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr 1fr" }}
    >
      {cards.map((segment, index) => (
        <Card
          index={index}
          id={segment.id}
          key={segment.id}
          name={segment.name!}
          segment={segment}
          description={segment.description!}
          segmentType={segment.segmentType}
          isSelected={selected?.some((s) => s.id === segment.id) || false}
          onSelect={onSegmentSelect}
          selectionDisabled={selectionDisabled}
        />
      ))}
    </Box>
  );
}

export { SegmentCards };
